import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Input, Chip } from "@nextui-org/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRemove } from "@fortawesome/free-solid-svg-icons";
import { usePost } from '../../api/reactQueryCustomHooks';
import { apiRoute } from '../../constants/enum';
import { toast } from 'react-toastify';
import { isMobile } from 'react-device-detect';
import { calculateTotal } from '../../Utility/utility';

const BUNCH_SIZE = 12;

const MemoizedRow = React.memo(
    ({ ele, index, row, gridField, handleKeyDown, handleBlur, handleChange, fnIsWithoutTaka, handleRemoveTaka }) => (
        <tr key={ele[gridField.id] || `${index}-${row}`}>
            <td className='text-center font-semibold'>{index * BUNCH_SIZE + row + 1}</td>
            {!fnIsWithoutTaka() && (
                <td className='py-1'>
                    <input
                        type="text"
                        name={gridField.takano}
                        className="border rounded-md px-2 py-1 w-[60px]"
                        value={ele[gridField.takano] || ''}
                        onKeyDown={(e) => handleKeyDown(index, row, e, ele[gridField.id], "taka")}
                        onChange={(e) => handleChange(index, row, e)}
                        onBlur={(e) => handleBlur(index, row, e, ele[gridField.id], "taka")}
                    />
                </td>
            )}
            <td className='py-1'>
                <input
                    type="text"
                    name={gridField.meter}
                    className="border rounded-md px-2 py-1 w-[60px]"
                    value={ele[gridField.meter] || ''}
                    onKeyDown={(e) => handleKeyDown(index, row, e, ele[gridField.id], "meter")}
                    onChange={(e) => handleChange(index, row, e)}
                />
            </td>
            <td className='text-center w-8'>
                <FontAwesomeIcon icon={faRemove} onClick={() => handleRemoveTaka(index, row)} className="cursor-pointer text-red-500" />
            </td>
        </tr>
    )
);

const GrayItemsDetail = ({
    grayItemData,
    selectedGridItem,
    handleSelectedGrayItem,
    isManualEntry,
    curAddedTaka,
    isDespLotNo,
    totalAllowTaka,
    isWithoutTaka,
}) => {
    const inputRef = useRef();
    const { compCode } = useSelector((state) => state.company);
    const [tempval, setTempVal] = useState("");
    const [bunchStates, setBunchStates] = useState([]);

    const gridField = {
        takano: "Taka_No",
        meter: "Meter",
        id: "Id",
        lotno: "Lot_No",
        takaid: "TakaId",
        inwcompcode: "InwCompCode"
    };

    const fnIsWithoutTaka = () => isManualEntry && isWithoutTaka;

    const { isPending, isError, data: takaListcheckDup = [], mutate: funTakaNoList } = usePost({
        url: apiRoute.transaction.SaleEntry.fetchTakaListTocheck,
        queryKey: "fetchTakalIst",

    })
    useEffect(() => {
        if (isManualEntry) {
            funTakaNoList({
                data: {
                    compcode: compCode.join(",")
                }
            })
        }

    }, [])

    // Generate data on initial mount
    useEffect(() => {
        if (grayItemData?.length > 0) {
            let t_lotNo = 1
            let count = 0;
            const rows = [];
            for (let i = 0; i < 96; i++) {
                // if (i >= rowCount) break; // Terminate the loop after 96 rows
                let newRow
                //rows.push(selectedGridItem[i]);
                if (isDespLotNo) {
                    count++;
                    if (count == BUNCH_SIZE + 1) {
                        t_lotNo++
                        count = 1
                    }
                }
                else
                    t_lotNo = ""

                const blankObj = {};
                // console.log(selectedGridItem[i]?.isAdded)
                // if (obj?.isAdded ) {
                if (selectedGridItem[i]?.isAdded) {
                    newRow = selectedGridItem[i]
                }
                else {
                    for (const key in selectedGridItem[i]) {

                        if (key == gridField.takano || key == gridField.meter) {
                            blankObj[key] = '';
                        }
                        else {
                            blankObj[key] = selectedGridItem[i][key] // Set the value to an empty string
                        }
                    }
                    newRow = { ...blankObj, isAdded: false, Lot_No: t_lotNo };

                }
                rows.push(newRow);
            }

            const bunches = [];
            for (let i = 0; i < rows.length; i += BUNCH_SIZE) {
                bunches.push(rows.slice(i, i + BUNCH_SIZE));
            }

            setBunchStates(bunches);
        }
    }, [grayItemData]);

    const handleChange = useCallback((bunchIndex, rowIndex, e) => {
        const { name, value } = e.target;

        setBunchStates(prev => {
            const updatedBunches = [...prev];
            const bunch = [...updatedBunches[bunchIndex]];

            bunch[rowIndex] = {
                ...bunch[rowIndex],
                [name]: value,
                ...(name === gridField.meter && { isAdded: true, isDeleted: false })
            };

            updatedBunches[bunchIndex] = bunch;
            return updatedBunches;
        });
    }, []);

    const handleRemoveTaka = useCallback((bunchIndex, rowIndex) => {
        setBunchStates(prev => {
            const updatedBunches = [...prev];
            const bunch = [...updatedBunches[bunchIndex]];

            bunch[rowIndex] = {
                ...bunch[rowIndex],
                [gridField.meter]: "",
                [gridField.inwcompcode]: 0,
                [gridField.takano]: "",
                isAdded: false,
                isDeleted: true,
            };

            updatedBunches[bunchIndex] = bunch;
            return updatedBunches;
        });
    }, []);


    const funSetManualEntry = (bunchIndex, rowIndex, id, name) => {
        const newBunch = [...bunchStates];
        let t_takano = newBunch[bunchIndex][rowIndex][gridField.takano];
        setTempVal("");

        let isduplicate = false;
        let isCurDelete = false;

        if (t_takano !== "" && (name === "taka" || name === "meter")) {
            for (const bunch of newBunch) {
                const selectedRow = bunch.find(item => item[gridField.takano]?.toLowerCase() === t_takano.toLowerCase());
                if (selectedRow) {
                    if (!selectedRow.isAdded) isCurDelete = true;
                    if (selectedRow[gridField.id] !== id) isduplicate = true;
                }
            }

            const selTakaNo = takaListcheckDup?.find(item => item[gridField.takano]?.toLowerCase() === t_takano.toLowerCase());
            if (selTakaNo && !isCurDelete) isduplicate = true;

            const sel = curAddedTaka?.find(item => item[gridField.takano]?.toLowerCase() === t_takano.toLowerCase());
            if (sel) isduplicate = true;

            if (isduplicate) {
                toast.error(`Taka No ${t_takano} is already added`, { position: "top-center" });
                setTempVal(`Taka No ${t_takano} is already added`);
                inputRef.current?.focus();
                newBunch[bunchIndex][rowIndex][gridField.takano] = "";
                setBunchStates(newBunch);
            }
        }
    };

    const funSetStockEntry = (bunchIndex, rowIndex, id, name) => {
        const newBunch = [...bunchStates];
        const value = newBunch[bunchIndex][rowIndex][gridField.takano];
        setTempVal("");

        if (isMobile ? (value !== "" && !newBunch[bunchIndex][rowIndex].isAdded) : value !== "") {
            const selectedRow = grayItemData.find(item => item[gridField.takano]?.toLowerCase() === value.toLowerCase());

            if (selectedRow) {
                const allItems = newBunch.flat();
                const checkDuplicate = allItems.find(ele => ele[gridField.takano]?.toLowerCase() === selectedRow[gridField.takano]?.toLowerCase());

                if (checkDuplicate) {
                    if (checkDuplicate.isAdded && id !== checkDuplicate.Id) {
                        if (!toast.isActive('toast_tadd')) {
                            toast.error("Taka added", { position: "top-center", toastId: "toast_tadd" });
                        }
                        setTempVal("Taka Added");
                        inputRef.current?.focus();
                        newBunch[bunchIndex][rowIndex][gridField.takano] = "";
                        newBunch[bunchIndex][rowIndex][gridField.meter] = "";
                        newBunch[bunchIndex][rowIndex].isAdded = false;
                        setBunchStates(newBunch);
                    } else {
                        const updatedRow = {
                            ...newBunch[bunchIndex][rowIndex],
                            [gridField.meter]: selectedRow[gridField.meter],
                            isAdded: true,
                            [gridField.takaid]: selectedRow.TakaId,
                            [gridField.inwcompcode]: selectedRow[gridField.inwcompcode],
                            isDeleted: false,
                        };
                        newBunch[bunchIndex][rowIndex] = updatedRow;
                        setBunchStates(newBunch);
                    }
                }
            } else {
                if (!toast.isActive('toast_ntfound')) {
                    toast.error("Taka not found", { position: "top-center", toastId: "toast_ntfound" });
                }
                setTempVal("Taka not found");
                newBunch[bunchIndex][rowIndex][gridField.takano] = "";
                setBunchStates(newBunch);
            }
        }
    };

    const handleKeyDown = (bunchIndex, rowIndex, event, id, name) => {
        if (totalAddedTaka > totalAllowTaka) {
            
            setBunchStates(prev => {
                const updatedBunches = [...prev];
                const bunch = [...updatedBunches[bunchIndex]];

                bunch[rowIndex] = {
                    ...bunch[rowIndex],
                    isAdded: false, [gridField.takano]: "", [gridField.meter]: ""
                };

                updatedBunches[bunchIndex] = bunch;
                return updatedBunches;
            });
            if (!toast.isActive("toast_allowtaka")){
                toast.error(`You can't add 'Taka' more than ${totalAllowTaka} `, {
                    "position": "top-center",
                    toastId: "toast_allowtaka"
                })
            }
        }
        else {
            if (event.key === 'Tab') {
                if (isManualEntry) {
                    funSetManualEntry(bunchIndex,  rowIndex,id, name)
                }
                else {
                    funSetStockEntry(bunchIndex,  rowIndex,id, name)
                }
            }
        }
    };
    const handleBlur = (bunchIndex, row, event, rowIndex, name) => {
        if (isMobile) {
            if (isManualEntry) {
                funSetManualEntry(bunchIndex, row, rowIndex, name)
            }
            else {
                funSetStockEntry(bunchIndex, row, rowIndex, name)
            }
        }
    };

    const { selectedTaka, totalAddedTaka, totalStockMtr, totalStockPcs } = useMemo(() => {
        const all = bunchStates.flatMap(b => b);
        const selected = isManualEntry ? all.filter(ele => ele?.isAdded) : all.filter(ele => ele.isAdded && ele.TakaId != 0);
        const selIds = selected.map(itm => itm.TakaId).filter(Boolean);
        const stock = isManualEntry ? [] : grayItemData?.filter(ele => !selIds.includes(ele.TakaId) && ele.TakaId != 0);
        //console.log(selected,selIds)
        return {
            selectedTaka: all,
            totalAddedTaka: selected.length,
            totalStockMtr: stock?.reduce((sum, item) => sum + (item.Meter || 0), 0) || 0,
            totalStockPcs: stock?.length || 0
        };
    }, [bunchStates, grayItemData]);

    const handleLotNoChange = (e, index) => {
        const { value } = e.target;
        if (value.length <= 1) {
            setBunchStates((prevData) => {
                const newData = [...prevData];
                const updatedArray = newData[index].map(ele => ({ ...ele, [gridField.lotno]: value }));
                newData[index] = updatedArray;
                return newData;
            });
        }
    };
    const total_SelMtr = useMemo(
        () =>
            calculateTotal({
                data: selectedTaka,
                columnName: "Meter",
            }),
        [selectedTaka]
    )

    useEffect(() => {
        const all = bunchStates.flatMap(b => b);
        handleSelectedGrayItem(all);
    }, [bunchStates]);
    const thclass = " px-2 py-1 font-normal"
    return (
        <div>
            <div className='text-center text-green'>
                <div className='flex flex-wrap uppercase p-2 gap-2 justify-center text-md text-sky-700 font-bold'>
                    {!isManualEntry && (
                        <>
                            <h2 className="text-gray-700">Stock Pcs: {totalStockPcs}</h2>
                            <h2 className="text-gray-700">Meter: {totalStockMtr}</h2>
                        </>
                    )}
                    {selectedTaka && selectedTaka?.length > 0 ? <h2 className="text-rose-700">
                        {!isManualEntry ? "Sel" : "Total"} Pcs : {selectedTaka.filter((ele) => ele.isAdded == 1).length}</h2> : ""}

                    {selectedTaka && selectedTaka?.length > 0 ? <h2 className="text-rose-700">
                        Meter :  {total_SelMtr}
                        </h2> : "" 
                    }
                    {/* selectedTaka.filter((ele) => ele.isAdded == 1).reduce((sum, item) => sum + (item.Meter || 0), 0) || 0}</h2> : "" */}
                </div>
            </div>

            <div className="text-center" ref={inputRef}>
                {tempval && <Chip color="danger">{tempval}</Chip>}
            </div>

            <div className="flex gap-2 w-full flex-wrap mt-5">
                {bunchStates.map((bunch, index) => {
                    const lot_Meter = bunch?.reduce((sum, item) => sum + (parseFloat(item?.Meter || 0)), 0) || 0
                    const lot_Taka =bunch?.filter(item => item.isAdded)?.length || 0;
                    return (

                        <div className="ml-10" key={index}>

                            {isDespLotNo ?
                                <div className='flex gap-2 items-end justify'>
                                    <Input type="text" label="Lot#" labelPlacement="outside" placeholder="" size="sm" value={bunchStates[index][0][gridField.lotno]} 
                                    variant="flat" color="danger" className="text-center font-semibold max-w-10"
                                        onChange={(e) => handleLotNoChange(e, index)}
                                    ></Input>
                                    <Input type="text" label="Taka" value={lot_Taka} labelPlacement="outside" placeholder=""
                                        size="sm" isReadOnly={true} variant="flat" color="warning" className=" font-semibold max-w-14"

                                    ></Input>
                                    <Input type="text" label="Meter" value={lot_Meter} labelPlacement="outside" placeholder=""
                                        size="sm" isReadOnly={true} variant="flat" color="success" className=" font-semibold  max-w-20"

                                    ></Input>
                                </div> : ""}

                            <table className=" text-sm font-normal shadow ">
                                <thead className='bg-blue-700 p-5 text-white rounded-md'>
                                    <tr>
                                        <th className={thclass}>Sr.No</th>
                                        {!fnIsWithoutTaka() && <th className={thclass}>Taka No.</th>}
                                        <th className={thclass}>Meter</th>
                                        <th className={thclass} ></th>
                                    </tr>
                                </thead>
                                <tbody className='p-2'>
                                    {bunch.map((ele, row) => (

                                        <MemoizedRow
                                            key={ele[gridField.id] || `${index}-${row}`}
                                            ele={ele}
                                            index={index}
                                            row={row}
                                            gridField={gridField}
                                            handleChange={handleChange}
                                            handleKeyDown={handleKeyDown}
                                            handleBlur={handleBlur}
                                            fnIsWithoutTaka={fnIsWithoutTaka}
                                            handleRemoveTaka={handleRemoveTaka}
                                        />
                                        //</div>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )
                })}
            </div>
        </div>
    );
};

export default GrayItemsDetail;
